import { FC } from 'react';
import { Link } from '@tanstack/react-router';
import { cn } from '@new/lib';
import { type Notification } from '@teachur/http-client';
import { getNotificationIcon, formatNotificationTime } from '../../lib/helpers';

interface NotificationItemProps {
  notification: Notification;
  onMarkAsRead?: (id: number) => void;
  onClick?: (notification: Notification) => void;
}

export const NotificationItem: FC<NotificationItemProps> = ({
  notification,
  onMarkAsRead,
  onClick,
}) => {
  const Icon = getNotificationIcon(notification.data.type);

  const handleClick = () => {
    if (!notification.read && onMarkAsRead) {
      onMarkAsRead(notification.id);
    }
    onClick?.(notification);
  };

  return (
    <div className="bg-(--neutral-white-NW1000) hover:bg-(--primary-O200) rounded-md transition-colors">
      <Link
        to={notification.data.path}
        className={cn(
          'flex py-3 px-4 flex-col justify-center items-center self-stretch cursor-pointer no-underline!',
          !notification.read && 'bg-blue-50/30'
        )}
        onClick={handleClick}
      >
        <div className="flex items-center gap-4 self-stretch">
          <Icon className="w-4 h-4 text-(--primary-O1000)" />

          <div className="flex-1 min-w-0 flex flex-col gap-1">
            <div className="flex justify-between items-center self-stretch">
              <span className="text-(--neutral-black-NB1000) [font-size:var(--fs-l5)] [font-family:var(--font-montserrat)] font-medium leading-[150%] line-clamp-2 flex-1">
                {notification.text}
              </span>
              <span
                className="text-(--neutral-black-NB700) text-[12px] font-normal leading-normal whitespace-nowrap shrink-0"
                style={{ fontFamily: 'Montserrat' }}
              >
                {formatNotificationTime(notification.createdAt)}
              </span>
            </div>
          </div>
        </div>
      </Link>
    </div>
  );
};
